import React, { useEffect, useState } from "react";

import {
  CWidgetStatsA,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
} from "@coreui/react";
import { CIcon } from "@coreui/icons-react";
import { cilOptions } from "@coreui/icons";
import { CChartLine } from "@coreui/react-chartjs";
import { getDataWidgetEquipments, usersGetbyToken } from "../../apis";
import { enqueueSnackbar } from "notistack";
import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import "@coreui/coreui/dist/css/coreui.min.css";
import FondoDashboard from "./assets/bg-dashboard.jpg";
import { useRouterStore } from "../../../libs/stores";
import { OptionI } from "../../../libs/interfaces";
import {
  getValidRoutes,
  extractModuleBase,
  findClosestModuleByPath,
  normalizePath,
} from "../../../libs/helpers";
import { message } from "antd";
import DashboardLayout from "../../../pages/lib/dashboard/page";

export const Dashboard = () => {
  const navigate = useNavigate();
  const setOptionsFirst = useRouterStore((state) => state.setOptionsFirst);
  const location = useLocation();
  // OPTIMIZACIÓN: Solo obtener lo que necesitamos del store
  const validateModulesFromApi = useRouterStore(
    (state) => state.validateModulesFromApi
  );
  const setOptions = useRouterStore((state) => state.setOptions);

  // OPTIMIZACIÓN: Usar selectors específicos para evitar re-renders
  const modules = useRouterStore((state) => state.modules);

  const options = useRouterStore((state) => state.options);

  const previousModuleBase = useRouterStore(
    (state) => state.previousModuleBase
  );
  const setPreviousModuleBase = useRouterStore(
    (state) => state.setPreviousModuleBase
  );

  // OPTIMIZACIÓN: Memoizar validRoutes
  const validRoutesMap = React.useMemo(() => getValidRoutes(), []);

  // OPTIMIZACIÓN: Estado local para controlar cuándo validar
  const [hasValidatedInitially, setHasValidatedInitially] =
    React.useState(false);

  // OPTIMIZACIÓN: Memoizar la función de validación de usuario

  const [data, setData] = useState<any>({
    total: 0,
    equipments: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData();
  }, []);

  const handleValidate = React.useCallback(async () => {
    try {
      await usersGetbyToken();
    } catch (err: any) {
      message.error(err.toString());
    }
  }, []);

  React.useEffect(() => {
    if (!hasValidatedInitially) {
      const initializeApp = async () => {
        await handleValidate();
        if (modules.length === 0) {
          await validateModulesFromApi();
        }
        setHasValidatedInitially(true);
      };
      initializeApp();
    }
  }, [
    hasValidatedInitially,
    handleValidate,
    validateModulesFromApi,
    modules.length,
  ]);

  // OPTIMIZACIÓN: Actualizar opciones cuando cambie la ruta o módulos
  React.useEffect(() => {
    if (!hasValidatedInitially || modules.length === 0) return;

    const currentPath = location.pathname;
    const moduleBase = extractModuleBase(currentPath);

    // Actualizar el módulo base actual
    if (previousModuleBase !== moduleBase) {
      setPreviousModuleBase(moduleBase);
    }

    const updateOptions = () => {
      const closestModule = findClosestModuleByPath(
        modules,
        normalizePath(currentPath)
      );

      if (closestModule?.options?.length) {
        const validRoutes = validRoutesMap[closestModule.to] || new Set();
        const validOptions = closestModule.options.filter((option) =>
          validRoutes.size > 0 ? validRoutes.has(option.to) : true
        );

        // Siempre actualizar las opciones para asegurar que se muestren
        setOptions(validOptions);
      } else {
        setOptions([]);
      }
    };

    // Usar setTimeout para asegurar que la actualización se ejecute después del render
    const timer = setTimeout(() => {
      updateOptions();
    }, 50);

    return () => clearTimeout(timer);
  }, [
    location.pathname,
    modules,
    hasValidatedInitially,
    validRoutesMap,
    setOptions,
    setPreviousModuleBase,
    previousModuleBase,
  ]);

  const getData = async () => {
    try {
      const { data: dataEquipments } = await getDataWidgetEquipments();
      if (!dataEquipments) return;

      setData({ ...dataEquipments });
      const getDatas_ = localStorage.getItem(
        process.env.REACT_APP_TOKEN_ROUTER!
      );

      const datas_ = JSON.parse(getDatas_!);
      let options_: OptionI[] = datas_.state.modules.find(
        (el: any) => el.to === "/equipments"
      )!.options!;
      setOptionsFirst(options_);
      setLoading(false);
    } catch (err: any) {
      enqueueSnackbar(err.toString(), { variant: "error" });
      console.log(err);
    }
  };

  const handleList = () => {
    navigate("/equipments");
  };

  const handleCrear = () => {
    navigate("/equipments/add");
  };

  return (
    <DashboardLayout/>
    // <div
    //   style={{
    //     position: "relative",
    //     height: "100%",
    //     width: "100%",
    //     maxWidth: "100%",
    //     overflowX: "hidden",
    //     overflowY: "hidden",
    //     backgroundImage: `url(${FondoDashboard})`,
    //     backgroundRepeat: "no-repeat",
    //     backgroundPosition: "center center",
    //     backgroundAttachment: "fixed",
    //     backgroundSize: "cover",
    //   }}
    // >
    //   {/* <div
    //     style={{
    //       position: "absolute",
    //       bottom: 10,
    //       left: 10,
    //       width: 140,
    //       background: "rgba(0,0,0,0.4)",
    //       color: "white",
    //       borderRadius: 2,
    //       padding: "5px",
    //     }}
    //   >
    //     double click , click, scroll
    //     <br />a letter to zoom
    //   </div> */}
    //   <Box sx={{ position: "absolute", top: 10, left: 10, zIndex: 2 }}>
    //     <CWidgetStatsA
    //       style={{
    //         width: 375,
    //         backgroundColor: "rgba(72, 61, 139, 0.5)",
    //         color: "white",
    //       }}
    //       // color="secondary"
    //       value={<>{data.total}</>}
    //       title="Activos"
    //       action={
    //         <CDropdown alignment="end">
    //           <CDropdownToggle
    //             color="transparent"
    //             caret={false}
    //             className="p-0"
    //           >
    //             <CIcon icon={cilOptions} className="text-white" />
    //           </CDropdownToggle>
    //           <CDropdownMenu>
    //             <CDropdownItem onClick={handleList}>Listar</CDropdownItem>
    //             <CDropdownItem onClick={handleCrear}>Crear</CDropdownItem>
    //           </CDropdownMenu>
    //         </CDropdown>
    //       }
    //       chart={
    //         <CChartLine
    //           className="mt-2 mx-3"
    //           style={{ maxHeight: "220px", height: "220px" }}
    //           data={{
    //             labels: data.equipments.map((el: any) => el?.name ?? ""),
    //             datasets: [
    //               {
    //                 label: "Total",
    //                 backgroundColor: "transparent",
    //                 borderColor: "rgba(255,255,255,.55)",
    //                 pointBackgroundColor: "#5856d6",
    //                 data: data.equipments.map((el: any) => el?.total ?? 0),
    //                 hoverBackgroundColor: "red",
    //               },
    //             ],
    //           }}
    //           options={{
    //             plugins: {
    //               legend: {
    //                 display: false,
    //               },
    //             },
    //             maintainAspectRatio: true,
    //             scales: {
    //               x: {
    //                 border: {
    //                   display: false,
    //                 },
    //                 grid: {
    //                   display: false,
    //                   // drawBorder: false,
    //                 },
    //                 ticks: {
    //                   display: true,
    //                 },
    //               },
    //               y: {
    //                 min: 1,
    //                 max: data.total,
    //                 display: false,
    //                 grid: {
    //                   display: false,
    //                 },
    //                 ticks: {
    //                   display: true,
    //                 },
    //               },
    //             },
    //             elements: {
    //               line: {
    //                 borderWidth: 1,
    //                 tension: 0.4,
    //               },
    //               point: {
    //                 radius: 4,
    //                 hitRadius: 10,
    //                 hoverRadius: 4,
    //                 hoverBackgroundColor: "red",
    //                 hoverBorderWidth: 20,
    //               },
    //             },
    //           }}
    //         />
    //       }
    //     />
    //   </Box>
    //   {/* <Box sx={{ zIndex: 1, width: "100%", height: "100%" }}>
    //     <Words />
    //   </Box> */}
    // </div>
  );
};
